import React from 'react';
import { useSubscriptionPaymentMethodQuery } from '../../../../graphql/graphql';
import Loading from '../../../BaseModule/Components/Loading';
import SubscriptionPaymentMethodSelectItem from './SubscriptionPaymentMethodSelectItem';
import styles from './SubscriptionPaymentMethodSelect.module.scss';

interface Props {
	subscriptionId: string;
	subscriptionPeriodId: string;
	onPaymentMethodSelect: (paymentMethod: string) => void;
}

const SubscriptionPaymentMethodSelect: React.FC<Props> = ({
	subscriptionId,
	subscriptionPeriodId,
	onPaymentMethodSelect,
}) => {
	const { data, isLoading } = useSubscriptionPaymentMethodQuery({
		input: {
			subscriptionId,
			subscriptionPeriodId,
		},
	});

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{data?.subscriptionPaymentMethods?.map(item => {
				if (item?.title && item?.type && item?.icon) {
					return (
						<SubscriptionPaymentMethodSelectItem
							title={item?.title}
							type={item?.type}
							icon={item?.icon}
							onClick={onPaymentMethodSelect}
						/>
					);
				}
			})}
		</div>
	);
};

export default SubscriptionPaymentMethodSelect;
